import { EntidadeBase } from 'hay-core-react';
class TemplateModel extends EntidadeBase {
  constructor() {
    super('template');
  }
}

export default new TemplateModel();
